import classNames from 'classnames';
import { IconInfo } from 'featherico';
import { ReactElement } from 'react';
import Tooltip from '../Tooltip';
import styles from './style.m.less';

type Props = {
    tooltip: ReactElement | string | null;
    marginLeft?: boolean;
    className?: string;
};

export default function TooltipInfoIcon({ tooltip, marginLeft = true, className }: Props) {
    return (
        <Tooltip
            tooltip={tooltip}
            className={classNames(className, styles.tooltipInfoIcon, { [styles.iconMargin]: marginLeft })}
        >
            <span aria-hidden="true">
                <IconInfo />
            </span>
        </Tooltip>
    );
}
